import script from "./ScenariosView.vue?vue&type=script&setup=true&lang=js"
export * from "./ScenariosView.vue?vue&type=script&setup=true&lang=js"

import "./ScenariosView.vue?vue&type=style&index=0&id=21e841c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21e841c0"]])

export default __exports__